(function () {
	'use strict';

	function getCookie(name) {
		var prefix = name + '=';
		var parts = document.cookie ? document.cookie.split(';') : [];
		for (var i = 0; i < parts.length; i++) {
			var c = parts[i].replace(/^\s+/, '');
			if (c.indexOf(prefix) === 0) return decodeURIComponent(c.substring(prefix.length));
		}
		return null;
	}

	function uuid() {
		if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0;
			var v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	var host = (document.body && document.body.dataset && document.body.dataset.host) || 'gl';
	var apiBase = host === 'uk' ? 'https://api.bloomperfume.co.uk' : 'https://api.bloomperfume.com';

	// Cross-domain bridge: при междоменном редиректе .com ↔ .co.uk
	// bloom_pixel_and_marketing.js → redirect_to_domain прокидывает bs_vid в URL.
	// Если URL содержит ?bs_vid=UUID — устанавливаем его в cookie на текущем
	// домене (.com / .co.uk scoped) и используем. Так один и тот же человек
	// сшивается между двумя магазинами Shopify под единым visitor_id.
	function adoptBsVidFromUrl() {
		try {
			var url = new URL(window.location.href);
			var urlVid = url.searchParams.get('bs_vid');
			if (!urlVid) return null;
			// UUID v4 sanity check — не доверяем произвольному значению из URL
			if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(urlVid)) return null;
			// Set cookie на текущем домене (root) на 2 года, как делает lambda /session/v
			var d = new Date();
			d.setTime(d.getTime() + 2 * 365 * 86400 * 1000);
			document.cookie = 'bs_vid=' + urlVid + '; expires=' + d.toUTCString() +
				'; path=/; domain=.' + location.hostname.replace(/^www\./, '') + '; SameSite=Lax';
			// Стираем bs_vid из URL — pixel-and-marketing нас оставил, чтобы мы успели прочитать;
			// теперь chистим, чтобы пользователь не торчал перед ?bs_vid=… в адресной строке
			// и чтобы не утекало при шаринге URL'а.
			url.searchParams.delete('bs_vid');
			if (window.history && window.history.replaceState) {
				window.history.replaceState(null, '', url.pathname + (url.search ? url.search : '') + url.hash);
			}
			return urlVid;
		} catch (e) { return null; }
	}

	function pingVisitor() {
		var adopted = adoptBsVidFromUrl();
		var existing = adopted || getCookie('bs_vid');
		if (existing) {
			window.__bsVisitorId = existing;
			return Promise.resolve(existing);
		}
		return fetch(apiBase + '/session/v?host=' + encodeURIComponent(host), { credentials: 'include' })
			.then(function (r) { return r.status === 204 ? null : r.json(); })
			.then(function (j) {
				var vid = (j && j.visitor_id) || getCookie('bs_vid');
				window.__bsVisitorId = vid;
				return vid;
			})
			.catch(function () { return null; });
	}

	function loadSession() {
		try { return JSON.parse(localStorage.getItem('bs_session') || 'null'); }
		catch (e) { return null; }
	}

	function saveSession(s) {
		try { localStorage.setItem('bs_session', JSON.stringify(s)); } catch (e) {}
	}

	// referrer-based fallback для UTM когда меток нет — частые соцсети/поисковики.
	// Если utm_source явно задан — он побеждает.
	function inferFromReferrer() {
		var ref = document.referrer || '';
		if (!ref) return { source: null, medium: null };
		try {
			var host = new URL(ref).hostname.toLowerCase();
			// свой домен — не считаем external referrer
			if (host.indexOf('bloomperfume') !== -1) return { source: null, medium: null };
			if (/google\./.test(host))                     return { source: 'google',    medium: 'organic' };
			if (/bing\./.test(host))                       return { source: 'bing',      medium: 'organic' };
			if (/duckduckgo\./.test(host))                 return { source: 'duckduckgo',medium: 'organic' };
			if (/yandex\./.test(host))                     return { source: 'yandex',    medium: 'organic' };
			if (/(^|\.)instagram\./.test(host))            return { source: 'instagram', medium: 'social'  };
			if (/(^|\.)facebook\./.test(host) || host === 'm.facebook.com' || host === 'l.facebook.com')
															return { source: 'facebook',  medium: 'social'  };
			if (/(^|\.)twitter\.|(^|\.)t\.co/.test(host))  return { source: 'twitter',   medium: 'social'  };
			if (/(^|\.)x\.com/.test(host))                 return { source: 'x',         medium: 'social'  };
			if (/(^|\.)tiktok\./.test(host))               return { source: 'tiktok',    medium: 'social'  };
			if (/(^|\.)pinterest\./.test(host))            return { source: 'pinterest', medium: 'social'  };
			if (/(^|\.)reddit\./.test(host))               return { source: 'reddit',    medium: 'social'  };
			if (/(^|\.)youtube\./.test(host))              return { source: 'youtube',   medium: 'social'  };
			return { source: host, medium: 'referral' };
		} catch (e) { return { source: null, medium: null }; }
	}

	// Cookie fallback: bloom_pixel_and_marketing.js при загрузке страницы читает UTM
	// из URL и пишет в cookie `bloom_cookies_json`, ПОТОМ стирает их из URL через
	// history.replaceState. Без cookie fallback bs-tracker, выполняющийся позже
	// (defer), видит уже почищенный URL и теряет UTM (особенно critical для
	// cross-domain redirect: .com → .co.uk прокидывает UTM в URL, но pixel-and-marketing
	// успевает стереть до того как identity подхватит).
	function readUtmFromBloomCookie() {
		try {
			var m = document.cookie.match(/(?:^|;\s*)bloom_cookies_json=([^;]*)/);
			if (!m) return {};
			var json = JSON.parse(decodeURIComponent(m[1]));
			return {
				utm_source:   json.utm_source   || null,
				utm_medium:   json.utm_medium   || null,
				utm_campaign: json.utm_campaign || null,
				utm_term:     json.utm_term     || null,
				utm_content:  json.utm_content  || null
			};
		} catch (e) { return {}; }
	}

	function getUtm() {
		var p = new URLSearchParams(window.location.search);
		var c = readUtmFromBloomCookie();
		var fallback = inferFromReferrer();
		// Приоритет: URL → bloom_cookies_json → referrer → null
		return {
			utm_source:   p.get('utm_source')   || c.utm_source   || fallback.source || null,
			utm_medium:   p.get('utm_medium')   || c.utm_medium   || fallback.medium || null,
			utm_campaign: p.get('utm_campaign') || c.utm_campaign || null,
			utm_term:     p.get('utm_term')     || c.utm_term     || null,
			utm_content:  p.get('utm_content')  || c.utm_content  || null
		};
	}

	function isSessionStillValid(s, currentUtm) {
		if (!s) return false;
		if ((Date.now() - s.last_activity) > 30 * 60 * 1000) return false;
		if (currentUtm.utm_source && s.utm.utm_source && currentUtm.utm_source !== s.utm.utm_source) return false;
		return true;
	}

	function ensureSession() {
		var utm = getUtm();
		var s = loadSession();
		var fresh = false;
		if (!isSessionStillValid(s, utm)) {
			s = {
				session_id: uuid(),
				started_at: Date.now(),
				last_activity: Date.now(),
				utm: utm,
				landing_url: location.pathname
			};
			fresh = true;
		} else {
			s.last_activity = Date.now();
		}
		saveSession(s);
		window.__bsSession = s;
		return { session: s, fresh: fresh };
	}

	// Brevo `?_se=<base64(email)>` — анонимный identifier который Brevo подсовывает
	// при клике в email-рассылке. Захватываем синхронно на script-load пока тема не
	// почистила query через history.replaceState. Используется для per-user атрибуции
	// incognito-визитов: bootstrap эмитит identify с этим email'ом, lambda резолвит
	// в customer_id через Shopify customer.search.
	function decodeSeEmail() {
		try {
			var p = new URLSearchParams(window.location.search);
			var se = p.get('_se');
			if (!se) return null;
			var email = atob(se);
			if (email && email.indexOf('@') > 0 && email.length < 200) return email;
		} catch (e) {}
		return null;
	}

	window.__bsApiBase = apiBase;
	window.__bsHost    = host;
	window.__bsPing    = pingVisitor;
	window.__bsEnsureSession = ensureSession;
	window.__bsUuid    = uuid;
	window.__bsSeEmail = decodeSeEmail();
})();
